const getters = {
    token: state => state.auth.token,
    refreshToken: state => state.auth.refreshToken,
    tokenV2: state => state.auth.tokenV2,
    isRefreshing: state => state.auth.isRefreshing,
    user: state => state.auth.user,
    oldPanel: state => state.app.old_panel,
    datatableCancel: state => state.app.datatableCancel,
    formTrackerCancel: state => state.formTracker.loadCancel,
    companiesRestricted: state => state.app.companiesRestricted,
}

export default getters
